import { Machine } from "xstate";

const questionMachine = Machine({
    initial: "idle",
    context: {
      tries: 0,
    },
    states: {
      idle: {
        on: {
          FIRST_ANSWER: [
            {
              target: "correct",
              cond: (ctx, event) => event.correct,
            },
            {
              target: "firsttryincorrect",
            },
          ],
          HASH_ANSWER:[
            {
              target: "correct",
              cond: (ctx, event) => event.correct,
            },
            {
              target: "incorrect",
            },
          ]
        },
      },
      firsttryincorrect: {
        on: {
          SECOND_TRY: "secondtry",
        },
      },
      secondtry: {
        on: {
          SECOND_ANSWER: [
            {
              target: "correct",
              cond: (ctx, event) => event.correct,
            },
            {
              target: "incorrect",
            },
          ],
        },
      },
      correct: {
        on: {
          RESTART: "idle"
        }
      },
      incorrect: {
        on: {
          RESTART: "idle"
        }
      },
    },
  });
  
export default questionMachine;